export const PORTFOLIO = {
  pre: "Portfolio",
  heading: "Checkout my work.",
};
